/* global Blockly */
import React from 'react';
import PropTypes from 'prop-types';
import util from '../../../../../../../utils/es5Utils';
import { mapIcon } from '../../../../v1/blocks/WidgetValues/Map';


function defineBlock(context) {
    return {
        init: function () {
            const selectMapDropdown = new Blockly.FieldWidgetsDropdown(context, 'map', undefined, '- select -');

            this.appendDummyInput('WIDGET')
                .appendField('update')
                .appendField(new Blockly.FieldImage(mapIcon, 30, 30, 'map icon', null), 'mapIcon')
                .appendField(selectMapDropdown, 'ID');

            this.appendValueInput('MARKER_ID')
                .appendField('marker')
                .setCheck('String');

            this.appendValueInput('LATITUDE')
                .appendField('to coordinates')
                .setCheck('Number');

            this.appendValueInput('LONGITUDE')
                .appendField(',')
                .setCheck('Number');

            this.appendValueInput('WIDGET_COLOR')
                .appendField('with color')
                .setCheck('Colour');

            this.setPreviousStatement(true);
            this.setNextStatement(true);
            this.setColour(Blockly.Msg.WIDGET_VALUES_HUE);
            this.setTooltip('Update a map marker\'s coordinates and color using its Marker ID.');
            this.setHelpUrl(`${Blockly.BASE_HELP_URL}#maps`);
        }
    };
}

function defineGenerators() {
    return {
        'JavaScript': function (block) {
            const mapId = block.getFieldValue('ID');
            const markerId = Blockly.JavaScript.valueToCode(block, 'MARKER_ID', Blockly.JavaScript.ORDER_NONE) || "''";
            const latitude = Blockly.JavaScript.valueToCode(block, 'LATITUDE', Blockly.JavaScript.ORDER_FUNCTION_CALL) || '0';
            const longitude = Blockly.JavaScript.valueToCode(block, 'LONGITUDE', Blockly.JavaScript.ORDER_FUNCTION_CALL) || '0';
            const color = Blockly.JavaScript.valueToCode(block, 'WIDGET_COLOR', Blockly.JavaScript.ORDER_NONE) || "'#FF0000'";
            return `Snap.widgets.map.updateMarker('${mapId}', ${markerId}, ${latitude}, ${longitude}, ${color});\n`;
        }
    };
}

const UpdateMarker = function (props) {
    const name = 'snap_map_update_marker_V3';
    UpdateMarker.blockName = name;

    Blockly.Blocks[name] = defineBlock(props.context);
    const generators = defineGenerators();
    for (const generator in generators) {
        Blockly[generator][name] = generators[generator];
    }

    return util.widgetsOfType(props.context, 'map').length ?
        <block type={name}>
            <value name="MARKER_ID">
                <shadow type="fixed_width_text">
                    <mutation length="9"></mutation>
                </shadow>
            </value>
            <value name="LATITUDE">
                <shadow type="math_number"></shadow>
            </value>
            <value name="LONGITUDE">
                <shadow type="math_number"></shadow>
            </value>
            <value name="WIDGET_COLOR">
                <shadow type="colour_picker">
                    <field name="COLOUR">#FF0000</field>
                </shadow>
            </value>
        </block> :
        null;
};

UpdateMarker.propTypes = {
    context: PropTypes.object
};

export default UpdateMarker;
